import adminApi from '@/api/admin/adminClient';
import { ENDPOINTS } from '@/api/endpoints';
import type { ApiEnvelope } from '@/types/dashboard/auth';
import type { AdminTransaction } from '@/types/dashboard/transaction';

export const transactionService = {
  /** Newest first. `from` / `to` are inclusive YYYY-MM-DD dates; `limit` caps the rows returned. */
  async list(
    params: { vendor?: number; kiosk?: number; from?: string; to?: string; limit?: number } = {},
  ): Promise<AdminTransaction[]> {
    const { data } = await adminApi.get<ApiEnvelope<AdminTransaction[]>>(ENDPOINTS.admin.transactions.list, { params });
    return data.data;
  },
};
